import { useRouter } from "vue-router";
import { useFrankStore } from "../../frank/store/frankStore";
import { useOrderStore } from "../stores/orderStore";
import { logAnalyticsEvent } from "../../../../assets/js/helpers/bananas";
import { useEnergyComparisonStore } from "../stores/energyComparison";
import { convertLocationToUrlQuery } from "../../../../assets/js/helpers/comparison-url";
import { computed } from "vue";

export function useProductClick(productRef) {
    const orderStore = useOrderStore();
    const frankStore = useFrankStore();
    const comparisonStore = useEnergyComparisonStore();
    const router = useRouter();

    const handleClick = () => {
        if (!productRef.value) return;

        const product = productRef.value;

        const clickOutEventData = {
            product_id: product.base_id,
            rank: product.rank,
            provider_name: product.provider_name,
            conversion_value: product.mcCval,
            outclick_type: product.orderline ? 'orderline' : 'outclick-screen',
            contract_duration: product.contract_duration,
            product_name: product.base_name,
            cashback: product.price_calculation?.total_discount,
            gift_value: product.gift_value,
        };

        logAnalyticsEvent(`compare-energy.outclick`, clickOutEventData);

        if (product.disabled || product.providerSlug === 'anwb-energie') {
            return;
        }

        if (product.orderline) {
            orderStore.setProduct(product);
            router.push({ name: 'form' });
        } else {
            frankStore.setFrankProduct(product);
        }
    };

    const clickoutUrl = computed(() => {
        if (!productRef.value || productRef.value.orderline) return false;

        return router.resolve({
            name: 'productLink',
            params: {
                provider: productRef.value.provider,
                productID: productRef.value.base_id,
            },
            query: {
                ...convertLocationToUrlQuery(comparisonStore.compareLocation),
            },
        }).href;
    });

    const dataAttributes = computed(() => {
        if (!productRef.value) return {};

        return {
            'data-mc-cval': productRef.value.cval,
            'data-mc-pt': 'energie',
            'data-mx-pid': productRef.value.base_id,
        };
    });

    return { handleClick, clickoutUrl, dataAttributes };
}
